var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('employ-edit',{attrs:{"row":_vm.row,"company-id":_vm.companyId,"opType":_vm.opType},on:{"close":_vm.close,"update":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }